import { NgModule } from '@angular/core';
import { TimeToDatePipe } from './time-to-date.pipe';

@NgModule({
  declarations: [TimeToDatePipe],
  exports: [TimeToDatePipe],
})
export class TimeToDateModule {}
